/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbWithTooltip } from "abreact/popup/AbWithTooltip";
import { AbSizeContext, sizeProviderWrapper } from "abreact/misc/AbSize";
import * as React from "react";
/**
 * Decorates the children with a notification-count-esque badge at the top right corner.
 * Designed to work when the child has standard height (--ab-size-default-height) and right padding
 * (--ab-size-default-padding).
 */
export const AbBadgeIndicator = props => {
  const contextSize = React.useContext(AbSizeContext);
  const maxValue = props.maxValue && props.maxValue > 0 ? props.maxValue : 99;
  const inner = /*#__PURE__*/React.createElement("div", ReactUtils.componentProps("ab-badge-indicator", props, [props.size ?? contextSize]), /*#__PURE__*/React.createElement("div", {
    className: "ab-badge-indicator-children"
  }, props.children), props.value !== undefined && props.value > 0 && /*#__PURE__*/React.createElement(AbWithTooltip, {
    tooltip: props.value > maxValue ? props.value : undefined
  }, /*#__PURE__*/React.createElement("div", {
    className: "ab-badge-indicator-badge"
  }, props.value > maxValue ? `${maxValue}+` : props.value.toString())));
  return sizeProviderWrapper(inner, props, contextSize);
};
//# sourceMappingURL=AbBadgeIndicator.js.map
